import type { SwitchProps } from "@mui/material/Switch"

import IOSSwitchPrimary from "@components/switch/primary"
import IOSSwitchSuccess from "@components/switch/success"
import IOSSwitchWarning from "@components/switch/warning"

export default function Switch(props: SwitchProps) {
  if (props?.color === "success") {
    return <IOSSwitchSuccess {...props} />
  }

  if (props?.color === "warning") {
    return <IOSSwitchWarning {...props} />
  }

  return <IOSSwitchPrimary {...props} />
}
